<template lang="pug">
  .padre
    .title
      span Mis pendientes
    .message-body(v-if="closeComponentUsuario")
      strong No tiene pendientes
    .display-flex.fdc
      .usuario.display-flex.fdr.space-evenly.flex-wrap
        .card-component(v-if="showCantidadMisDocumentosSinFirmar" @click="redirigir('mis-documentos-firmar')")
          cantidad-mis-documentos-sin-firmar(@close="close('showCantidadMisDocumentosSinFirmar')")
        .card-component(v-if="showCantidadMisContratosSinFirmar" @click="redirigir('mis-contratos')")
          cantidad-mis-contratos-sin-firmar(@close="close('showCantidadMisContratosSinFirmar')")
        .card-component(v-if="showCantidadMisBoletasSinVisualizar" @click="redirigir('boletas')")
          cantidad-mis-boletas-sin-visualizar(@close="close('showCantidadMisBoletasSinVisualizar')")
    .display-flex.space-evenly.flex-wrap
      kpi-cumpleanos
      kpi-cursos
</template>

<script>
import CantidadMisDocumentosSinFirmar from './kpis/c_kpi_cantidad_mis_documentos_sin_firmar';
import CantidadMisContratosSinFirmar from './kpis/c_kpi_cantidad_mis_contratos_sin_firmar';
import CantidadMisBoletasSinVisualizar from './kpis/c_kpi_cantidad_mis_boletas_sin_visualizar';
import KpiCumpleanos from './kpis/c_kpi_cumpleanos'
import KpiCursos     from './kpis/c_kpi_cursos'

export default {
  name: 'Dashboard_usuario',
  components: {
    'cantidad-mis-documentos-sin-firmar':CantidadMisDocumentosSinFirmar,
    'cantidad-mis-contratos-sin-firmar':CantidadMisContratosSinFirmar,
    'cantidad-mis-boletas-sin-visualizar':CantidadMisBoletasSinVisualizar,
    'kpi-cumpleanos'                     : KpiCumpleanos,
    'kpi-cursos'                         : KpiCursos
  },
  data () {
    return {
      isHorizontal: false,
      showCantidadMisDocumentosSinFirmar: true,
      showCantidadMisContratosSinFirmar:true,
      showCantidadMisBoletasSinVisualizar:true
    }
  },
  computed: {
    closeComponentUsuario () {
      return !this.showCantidadMisDocumentosSinFirmar && !this.showCantidadMisContratosSinFirmar && !this.showCantidadMisBoletasSinVisualizar
    }
  },
  methods:{
    redirigir (to, isQuery) {
      var objPush = { path: `/${to}` }
      if (isQuery) {
        let queryParamsValues = {
          'reporte-contratos': { firmado : 0 },
          'reporte-documentos-firmar': { estado : 1 },
          'boletas-reporte': { visto:0, anio:'all', mes:'all', tipo:'all' }
        }
        objPush.query = queryParamsValues[to]
      }
      this.$router.push(objPush)
    },
    handleResize () {
      if (window.innerWidth <= 820) {
        this.$store.dispatch('setSidebarDesktop', true)
        localStorage.setItem('sidebar-show', true)
      } else if (window.innerWidth < 1140) {
        this.$store.dispatch('setSidebarDesktop', false)
        localStorage.setItem('sidebar-show', false)
      }
    },
    close (componente) {
      this[componente] = false
    }
  }
};
</script>

<style lang="stylus" scoped>
/* Puedes agregar estilos personalizados aquí si es necesario */
.padre
  display flex
  flex-direction column
  box-sizing border-box
  .title
    padding-right: 12px;
    padding-left: 12px;
    font-size 16px
    span
      font-weight bold
      text-transform uppercase
  .card-component
    margin-top 10px
    margin-right 10px
  .contenedor-chart
    display flex
@media (max-width 1200px)
  .padre
    .contenedor-chart
      display: block
@media (max-width 428px)
  .padre
    .card-component
      margin-right 0px
      width 100%
      >>> .cuadro
        width 100%

</style>



// WEBPACK FOOTER //
// Component_Dashboard_KPI_usuario.vue?82b96bf8